module.exports = __webpack_public_path__ + "img/bg.8dca6c39.png";